module.exports = __webpack_public_path__ + "img/mb_banner.3ecc8774.jpg";